/* IfShe cart helpers (new code): ⬇ PNG downloads the original uploaded image as a file. */
(function () {
  'use strict';
  if (window.__ifsheCartJs) return;
  window.__ifsheCartJs = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ifshe-dl-png');
    if (!b) return;
    e.preventDefault();
    var url = b.getAttribute('data-url');
    var name = b.getAttribute('data-name') || 'image.png';
    var label = b.textContent;
    b.disabled = true;
    b.textContent = '…';
    fetch(url, { headers: { Accept: 'image/png,image/*' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
      .then(function (blob) {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = name;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
      })
      .catch(function () { window.open(url, '_blank', 'noopener'); })
      .then(function () { b.disabled = false; b.textContent = label; });
  });
})();
